import { render, staticRenderFns } from "./OfficeCard.vue?vue&type=template&id=6a1741ac&scoped=true&"
import script from "./OfficeCard.vue?vue&type=script&lang=js&"
export * from "./OfficeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1741ac",
  null
  
)

export default component.exports